import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, removeParam, getBaseDir, getBranchNameFromId } from '../../../utils.js';
import ReportFilter from '../../../components/report/ReportFilter.js';
import TableBuilder from '../../../table_builder.js';
const XLSX = require('xlsx');


const tableRef = new TableBuilder({
  table: '#table-patient-reports-list',
  tableBody: '.js-patient-reports-table',
  data: [],
  rowsPerPage: 25,
  filter: false,
  maxPages: 0,
  tableRowRenderer: function(rowData, opts) {
    return mountTableRow(rowData, opts);
  },
});

// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = $(this).text();
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-previous-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() - 1; //console.log('previous pageId', pageId);
  if (pageId <= 0)
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-next-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() + 1; //console.log('next pageId', pageId);
  if (pageId > tableRef.getMaxPages())
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});

$(document).on('click', '.js-patient-reports-wpp-message', function(e) {
  e.preventDefault();
  e.stopPropagation();

  let patientInfo = $(this).data('info');

  let firstName = patientInfo.NOME_COMPLETO.split(' ')[0];

  let message = `🔹 Olá, ${firstName}! Tudo bem?

Aqui é a Isabella, Gerente de Relacionamento da Clínica Ajustar 👋.

Vi que você realizou sua avaliação e o primeiro ajuste conosco na semana passada e gostaria de saber como foi sua experiência — desde o atendimento até como se sentiu após o ajuste.

Sua opinião é muito importante para que possamos  sempre melhorar 💙. 

Pode me contar?`;

  //console.log('patientInfo', patientInfo);
  //return console.log('message', message);
  //self.currentWppMessageScheduleData = scheduleData;
  //console.log('scheduleData.obj.CLIENTE_DADOS', scheduleData.obj.CLIENTE_DADOS);
  //console.log('splitPatientData', splitPatientData);
  //let nomePaciente = splitPatientData[0]
  //let sexo = splitPatientData[2] == 'M' ? 'Sr. ' : 'Sra. ';
  // Primeiro, defina o locale para português do Brasil
  moment.locale('pt-br');

  $('#agenda_patient').val(firstName);
  $('#agenda_phone').val(patientInfo.FONE_CELULAR);
  $('#agenda_send_whatsapp_message').val(message);

  $("#modal-agenda-send-whatsapp-message").modal('show');

  $('.js-agenda-send-whatsapp-message-submit-button').attr('data-first-name', firstName);
  $('.js-agenda-send-whatsapp-message-submit-button').attr('data-patient-id', patientInfo.ID);
});

$(document).on('click', '.js-agenda-send-whatsapp-message-submit-button', function(e) {
  if (window._sessionData.userId === 'gerenteisabella' || window._sessionData.userId === 'fellipeorsini') {
    e.preventDefault();
    let 
      selfBtn = $(this),
      firstName = $(this).data('first-name'),
      patientId = $(this).data('patient-id');

    console.log('firstName', firstName);
    console.log('patientId', patientId);

    selfBtn.addClass('disabled');
    apiCall({
      method: 'POST',
      endpoint: 'api/v1/patient/send_subscription_message',
      data: {
        firstName: firstName,
        patientId: patientId
      },
      successCallback: function(res) {
        window.toast({
          error: res.error,
          text: res.message
        });
        
        selfBtn.removeClass('disabled');
      },
      errorCallback: function() {
        window.toast({
          error: true,
          message: 'Ocorreu um erro ao enviar a mensagem. Tente novamente.'
        })
        selfBtn.removeClass('disabled');
      }
    });
  }
});

const copyToClipboard = (text) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  
  try {
      document.execCommand('copy');
      console.log('Text copied to clipboard');
  } catch (err) {
      console.error('Unable to copy to clipboard:', err);
  } finally {
      document.body.removeChild(textarea);
  }
}

const mountTableRow = (rowData, reportType) => {
  let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
    patient_id: rowData.ID,
    branch: rowData.FILIAL
  });

  return reportType !== 'LAST_PATIENT_SCHEDULES' ? `
    <tr>
      <td>${rowData.FILIAL ? rowData.FILIAL : rowData.LOCAL_CONVERSAO}</td>
      <td><a href="${url}" target="new">${rowData.NOME_COMPLETO}</a></td>
      <td>${rowData.DATA_NASCIMENTO === null ? 'Não informado' : rowData.DATA_NASCIMENTO}</td>
      <td>${rowData.EMAIL === null ? 'Não informado' : rowData.EMAIL}</td>
      <td>${rowData.FONE_CELULAR === null ? 'Não informado' : (window._sessionData.userId === 'gerenteisabella' || window._sessionData.userId === 'fellipeorsini' ? `<a href="javascript:void(0);" class="js-patient-reports-wpp-message" data-info='${JSON.stringify(rowData)}'>${rowData.FONE_CELULAR}</a>` : `${rowData.FONE_CELULAR}`)}</td>
    </tr>
  ` : `
    <tr>
      <td>${getBranchNameFromId(rowData.FILIAL_ID)}</td>
      <td>${rowData.CLIENTE_ID}</td>
      <td>${rowData.NOME_COMPLETO}</td>
      <td>${rowData.FONE_CELULAR}</td>
      <td>${rowData.DATA_ATENDIMENTO}</td>
      <td>${rowData.DIF} dias</td>
      <td>${rowData.QT_ABERTOS} abertos</td>
      <td>${rowData.PRIMEIRO_NOME}</td>
    </tr>
  `;
}

const PatientsReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBusinessBranches] = useState([]);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [hasAuthCode, setAuthCode] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);

  const [formData, setFormData] = useState({
    branch: '',
    branchName: '',
    startDate: '',
    endDate: '',
    reportType: '',
    recordsPerPage: 25,
    page: 1
  })
  const interval = useRef(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    setBusinessBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);

    tableRef.setFetchTableData(fetchTableData);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.reportType === '') {
      window.toast({
        error: true,
        text: "Selecione o tipo de relatório!"
      });
      return;
    }

    window.localStorage.setItem('patientsReportsFormData', JSON.stringify(formData));
    fetchTableData()
  }

  const fetchTableData = (pageId = false) => {
    let formData = JSON.parse(window.localStorage.getItem('patientsReportsFormData'));
    if (pageId) {
      formData.page = pageId;
      setFormData(formData);
      window.localStorage.setItem('patientsReportsFormData', JSON.stringify(formData));
    }
    
    setReportGenerated(false);
    setIsLoading(true);

    apiCall({
      endpoint: 'api/v1/reports/patients',
      method: 'GET',
      data: {
        ...formData
      },
      successCallback: (response) => {
        console.log('response', response);

        setReportGenerated(true);
        setIsLoading(false);

        formData.startDate = response.LABELS.startDate;
        formData.endDate = response.LABELS.endDate;
        setFormData(formData);
        window.localStorage.setItem('patientsReportsFormData', JSON.stringify(formData));

        setTimeout(() => { tableRef.renderPage(tableRef.getCurrentPage(), false, response.RESULTS, false, response.LABELS.total, formData.reportType) }, 1000);
      },
      errorCallback: (err) => {
        setIsLoading(false);
        console.error('error', err);
      }
    });
  }

  const exportToExcel = () => {
    let formData = JSON.parse(window.localStorage.getItem('patientsReportsFormData'));
    formData.export = true;
    apiCall({
      endpoint: 'api/v1/reports/patients',
      method: 'GET',
      data: {
        ...formData
      },
      successCallback: (response) => {
        console.log('response', response);

        const worksheet = XLSX.utils.json_to_sheet(response.RESULTS);

        // Create a workbook and add the worksheet to it
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Export the workbook to an Excel file
        XLSX.writeFile(workbook, 'relatorio_pacientes_'+window.getSaoPauloDateTime()+'.xlsx');

        window.toast({
            error: false,
            text: "Exportação realizada com sucesso."
        })
      },
      errorCallback: (err) => {
        console.error('error', err);
      }
    });
  }

  const exportJsPdf = () => {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    // Extract table
    doc.autoTable({
        html: '#table-patient-reports-list'
    });

    // Save the PDF
    doc.save('relatorio_pacientes_'+window.getSaoPauloDateTime()+'.pdf');
  }

  return (
    <>
     <div className="col-12 p-2">
      <div class="d-flex justify-content-center">
        <form className="row w-50" onSubmit={(e) => handleSubmit(e)}>
          <ReportFilter setFormData={setFormData} setAsOpen={true} />
          <div className="form-group mb-3">
            <label>Relatório:</label>
            <select className="form-control form-control" onChange={(e) => {
              setFormData((prev) => {
                return {
                  ...prev,
                  reportType: e.target.value,
                  days: '',
                  daysEnd: ''
                }
              });
              setReportGenerated(false);
            }}>
              <option selected default value="">-- Selecione --</option>
              {/*<option value="AVALIATION_EXAM">Quem agendou avaliação</option>*/}
              <option value="LEAD_NOT_SCHEDULED">Lead que não agendou</option>
              <option value="AVALIATION_EXAM_ATTENDED">Quem agendou avaliação e compareceu</option>
              <option value="AVALIATION_EXAM_NOT_ATTENDED">Quem agendou avaliação e NÃO compareceu</option>
              <option value="AVALIATION_EXAM_AND_BOUGHT_TREATMENT_PLAN">Quem fez avaliação e comprou tratamento (1° plano)</option>
              <option value="AVALIATION_EXAM_AND_DIDNT_BUY_TREATMENT_PLAN">Quem fez avaliação e NÃO comprou tratamento (1° plano)</option>
              <option value="HAVE_ACTIVE_TREATMENT_PLAN">Compraram plano e estão regulares</option>
              <option value="HAVE_INACTIVE_TREATMENT_PLAN">Compraram plano e NÃO estão regulares</option>
              <option value="HAVE_ACTIVE_TREATMENT_PLAN_AND_ONE_MAINTENANCE_PLAN">Compraram plano e 1 manutenção</option>
              <option value="HAVE_ACTIVE_TREATMENT_PLAN_AND_TWO_MAINTENANCE_PLAN">Compraram plano e 2 manutenção</option>
              <option value="HAVE_ACTIVE_TREATMENT_PLAN_AND_THREE_MAINTENANCE_PLAN">Compraram plano e 3+ manutenção</option>
              <option value="COMPLETED_TREATMENT_PLAN_AND_DIDNT_BUY_MAINTENANCE_PLAN">Finalizaram tratamento e não compraram manutenção</option>
              <option value="ENDING_CONTRACT_NO_RENOVATION">Pacientes fim de contrato sem renovação</option>
              <option value="BLOCKED_PATIENTS">Pacientes bloqueados</option>
              <option value="STARTING_TREATMENT_PATIENT">Pacientes Início de Tratamento</option>
              <option value="STARTING_MAINTENANCE_PATIENT">Pacientes Início de Manutenção</option>
              <option value="LAST_PATIENT_SCHEDULES">Último agendamento de pacientes</option>
              {/*<option value="PERCENTAGE_ACTIVE_TREATMENT_PLAN_">Quantos % terminou tratamento inicial</option>*/}
            </select>
          </div>
          {formData.reportType === 'LAST_PATIENT_SCHEDULES' && (
            <div className="form-group mb-3">
              <label>Dias desde último antedimento:</label>
              <input type="number" className="form-control" required={true} onChange={(e) => {
                setFormData((prev) => {
                  return {
                    ...prev,
                    days: e.target.value
                  }
                });
              }} />
              até
              <input type="number" className="form-control" required={true} onChange={(e) => {
                setFormData((prev) => {
                  return {
                    ...prev,
                    daysEnd: e.target.value
                  }
                });
              }} />
            </div>
          
          )}
          <div className="form-group mb-3">
            <button type='submit' className="btn btn-primary">Gerar Relatório</button>
            {formData.reportType && reportGenerated && (
              <>
                <button type="button" className='btn btn-secondary ml-2' onClick={() => exportToExcel()}>Exportar para Excel</button>
                <button type="button" className='btn btn-secondary ml-2' onClick={() => exportJsPdf()}>Exportar para PDF</button>
              </>
            )}
          </div>
        </form>
      </div>
      {isLoading && 'Carregando, por favor, aguarde...'}
      {formData.reportType && reportGenerated && (
        <>
          Relatório de pacientes {formData.reportType && `(${type[formData.reportType]})`}<br />Período: {formData.startDate} {formData.endDate !== '' && `até ${formData.endDate}`}
          <table className="table table-striped table-bordered" id="table-patient-reports-list">
            <thead>
              <tr>
                {formData.reportType == 'LAST_PATIENT_SCHEDULES' ? (
                  <>
                  <th>Filial</th>
                  <th>Cliente</th>
                  <th>Paciente</th>
                  <th>Celular</th>
                  <th>Ult. Atendimento</th>
                  <th>Dif. Dias</th>
                  <th>Sessões em Aberto</th>
                  <th>Quiropraxista</th>
                  </>
                ) : (
                  <>
                  <th>Filial</th>
                  <th>Nome completo</th>
                  <th>Data Nascimento</th>
                  <th>Email</th>
                  <th>Telefone</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody className="js-patient-reports-table"></tbody>
          </table>
        </>
      )}
      </div>
    </>
  );
}

try {
  if (document.getElementById('js-patients-reports-content')) {
    const container = document.getElementById('js-patients-reports-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<PatientsReports />);
  }
} catch(err) {
  console.error('PatientsReports error', err);
}

const type = {
  LEAD_NOT_SCHEDULED: "Lead que não agendou",
  AVALIATION_EXAM: 'Quem agendou avaliação',
  AVALIATION_EXAM_ATTENDED: 'Quem agendou avaliação e compareceu',
  AVALIATION_EXAM_NOT_ATTENDED: 'Quem agendou avaliação e NÃO compareceu',
  AVALIATION_EXAM_AND_BOUGHT_TREATMENT_PLAN: 'Quem fez avaliação e comprou tratamento (1° plano)',
  AVALIATION_EXAM_AND_DIDNT_BUY_TREATMENT_PLAN: 'Quem fez avaliação e NÃO comprou tratamento (1° plano)',
  HAVE_ACTIVE_TREATMENT_PLAN: 'Compraram plano e estão regulares',
  HAVE_INACTIVE_TREATMENT_PLAN: 'Compraram plano e NÃO estão regulares',
  HAVE_ACTIVE_TREATMENT_PLAN_AND_ONE_MAINTENANCE_PLAN: 'Compraram plano e 1 manutenção',
  HAVE_ACTIVE_TREATMENT_PLAN_AND_TWO_MAINTENANCE_PLAN: 'Compraram plano e 2 manutenção',
  HAVE_ACTIVE_TREATMENT_PLAN_AND_THREE_MAINTENANCE_PLAN: 'Compraram plano e 3+ manutenção',
  COMPLETED_TREATMENT_PLAN_AND_DIDNT_BUY_MAINTENANCE_PLAN: 'Finalizaram tratamento e não compraram manutenção',
  ENDING_CONTRACT_NO_RENOVATION: 'Pacientes fim de contrato sem renovação',
  BLOCKED_PATIENTS: 'Pacientes bloqueados',
  STARTING_TREATMENT_PATIENT: 'Pacientes Início de Tratamento',
  STARTING_MAINTENANCE_PATIENT: 'Pacientes Início de Manutenção',
  PERCENTAGE_ACTIVE_TREATMENT_PLAN_: 'Quantos % terminou tratamento inicial',
}